/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Other_SettingsInputs */



/**
* | output |
* | --- |
* | "Rounds & timer" |
*
* @param {Og_Cfg_Other_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_other_settings = /** @type {((inputs?: Og_Cfg_Other_SettingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Other_SettingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes et chrono")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas y cronómetro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas e cronômetro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round e timer")
	return /** @type {LocalizedString} */ ("Rounds & timer")
});